import { useContext, useMemo } from 'react';
import { UserContext } from '../../context';
import { useOrganisationTagsExternalQuery } from '../../services';
import { ORG_TAGS_SIZE_LIMIT } from '../constants';
import { FeedFollowBehavior } from '../models';
import { isAdminLayout } from '../utils';

interface UseFollowableTagsArgs {
  feedFollowedStatus?: boolean;
  feedFollowBehavior?: FeedFollowBehavior[];
}

export const useFollowableTags = ({
  feedFollowedStatus,
  feedFollowBehavior = [FeedFollowBehavior.OPTIONAL_FOLLOW, FeedFollowBehavior.OPTIONAL_UNFOLLOW],
}: UseFollowableTagsArgs = {}) => {
  const { isAnonymous } = useContext(UserContext).userProfile;

  const { data, isFetching } = useOrganisationTagsExternalQuery(
    {
      size: ORG_TAGS_SIZE_LIMIT,
      filters: { feedFollowBehavior, feedFollowedStatus },
    },
    { skip: isAnonymous || isAdminLayout() }
  );

  return useMemo(
    () => ({ followableTags: data?.items ?? [], isFetchingFollowableTags: isFetching }),
    [data?.items, isFetching]
  );
};
